import pathPrefix from '../../node_modules/nuxt-language-negotiation/dist/runtime/server/negotiator/pathPrefix.js'
import query from '../../node_modules/nuxt-language-negotiation/dist/runtime/server/negotiator/query.js'
import acceptLanguage from '../../node_modules/nuxt-language-negotiation/dist/runtime/server/negotiator/acceptLanguage.js'
const serverOptions = {}

export const negotiators = [
  pathPrefix({}),
  query({"keys":["language","langcode"]}),
  acceptLanguage({})
]

export { serverOptions }